import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Filter } from '@pretamanger/component-library'

export const BoxContains = styled('button')<{ isBlack?: boolean }>`
  ${tw`flex justify-between items-center rounded h-12 min-w-[156px] max-w-[289px] border-grey-700 border-[1px] p-3`}
  ${({ isBlack }) => (isBlack ? tw`bg-grey-700` : tw`bg-white`)}
  ${tw`lg:w-full`}
`

export const LabelVeganOption = styled('p')<{ isWhite?: boolean }>`
  ${tw`font-bold text-left`}
  ${({ isWhite }) => (isWhite ? tw`text-white` : tw`text-grey-700`)}
`

export const FilterIcon = styled(Filter)`
  color: black;
`

export const CircleCounter = styled('div')`
  ${tw`bg-white rounded-full py-1 px-2`}
`

export const Counter = styled('p')`
  ${tw`font-bold text-center text-[14px] leading-[14px] text-pretRed-700`}
`

export const SideBarFilter = styled('div')`
  ${tw`lg:mb-6 lg:px-3`}
`
